export const SET_PAYMENT_TYPE = (state, value) => {
  state.paymentType = value
}

export const SET_IBAN = (state, value) => {
  state.iban = value
}

export const SET_BENEFICIARY_NAME = (state, value) => {
  state.beneficiaryName = value
}

export const SET_BENEFICIARY_ADDRESS = (state, value) => {
  state.beneficiaryAddress = value
}

/* export const RESET_EXPIRATION_DATES = (state, value) => {
  state.expirationDates = value
}

export const ADD_EXPIRATION_DATE = (state, value) => {
  state.expirationDates.push(value)
}

export const REMOVE_EXPIRATION_DATE = (state, index) => {
  state.expirationDates.splice(index, 1)
}

export const UPDATE_EXPIRATION_DATE = (state, value) => {
  state.expirationDates[0].date = value
}

export const UPDATE_AMOUNT = (state, value) => {
  state.expirationDates[0].amount = value
}
*/
// export const SET_EXPIRATION_DATES = (state, value) => {}
